<template>
  <div class="commentIndex">
    <ul>
      <li @click="goDetail(i)" v-for='(i,k) in showData' :key='k'>{{i.name}}</li>
    </ul>
    <div class="page">
      <i class="left iconfont icon-youjiantou" @click="prePage()"></i>
      <div class="item" :class="{active: current===k}" v-for='(i,k) in new Array(Math.ceil(total / size))' :key='k'>
        <div @click="currentPage(k)">{{k+1}}</div>
      </div>
      <i class="right iconfont icon-youjiantou" @click="nextPage()"></i>
    </div>

  </div>
</template>

<script>
  export default {
    props: {
      data: Array
    },
    data() {
      return {
        showData: [],
        total: this.data.length,
        size: 5,
        current: 0
      }
    },
    created() {
      this.currentPage(0);
    },
    methods: {
      goDetail(data) {
        //   console.log(data)
        //   this.$$$api.activityDetail({id: data.id})
        this.$emit('detail', data)
      },
      nextPage() {
        if (this.current + 1 == Math.ceil(this.total / this.size)) {
        } else {
          this.current = this.current + 1;
        }
      },
      // 上一页
      prePage() {
        if (this.current == 0) {
        } else {
          this.current = this.current - 1;
        }
      },
      // 点击页码
      currentPage(i) {
        this.current = i;
        this.watch
      }
    },
    watch: {
      data: function (newData, oldData) {
        console.log("activity1", newData)  //newData就是orderData
        this.total = newData.length;
        this.showData = newData.slice(this.current * this.size, (this.current + 1) * this.size);
        //	methods的函数在这里调用可以获取到newOrderData的值
        //this.order();
      },
      current: function (newData, oldData) {
        console.log("activity1", newData)  //newData就是orderData
        this.showData = this.data.slice(newData * this.size, (newData + 1) * this.size);
        //	methods的函数在这里调用可以获取到newOrderData的值
        //this.order();
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~styl/mixin.styl"
  .commentIndex
    mt(20)
    min-height 350px

    ul
      pl(30)

      li
        fs(17)
        c(gray)
        lh(37)
        _hover()

  theme = #f7aa05

  .page
    ta(center)
    fs(0)

    .item
      ib()
      w(40)
      h(30)
      ml(10)
      mr(10)
      va(middle)
      fs(17)
      lh(30)
      c(gray)
      _hover()

      &.active
        bg(theme)
        c(#fff)

    .left
      fs(15)
      c(gray)
      ib()
      transform rotate(180deg)
      vertical-align -4px
      mr(10)

      &:hover
        cursor pointer

    .right
      &:hover
        cursor pointer
      ml(10)
      va(middle)
      c(gray)
      fs(15)

</style>



// WEBPACK FOOTER //
// src/components/comment/default.vue